import * as React from "react";
import { TextField, MenuItem, styled } from "@mui/material";

interface Props {
    items: { id: string; name: string }[];
    selected: string;
    // eslint-disable-next-line no-unused-vars
    onChangeSelected: (id: string) => void;
    size?: "small" | "medium";
}

export default function HardwareInterfaceSelector({ onChangeSelected, items, selected, size }: Props) {
    const smallCss = {
        "& .MuiOutlinedInput-input": {
            padding: "4px 30px 4px 10px",
            fontSize: "13px",
            minWidth: "60px",
            width: "100%",
            backgroundColor: "white",
        },
    };

    const CssTextField = styled(TextField)(size === "small" ? smallCss : { backgroundColor: "white" });
    const smallSizeText =
        size === "small" ? { fontSize: "14px", backgroundColor: "white" } : { backgroundColor: "white" };

    return (
        <CssTextField
            disabled={items.length === 0}
            select
            name="hwi"
            onChange={(e: any) => onChangeSelected(e.target.value)}
            variant="outlined"
            value={selected}
            fullWidth
        >
            {items.map((item) => (
                <MenuItem value={item.id} key={item.id} selected={selected === item.id} style={smallSizeText}>
                    {item.name}
                </MenuItem>
            ))}
        </CssTextField>
    );
}
